import React from 'react'

function SettingMessages() {
  return (
    <div className="setting-block">SettingMessages</div>
  )
}

export default SettingMessages